module.exports = __webpack_public_path__ + "static/img/key-icon.135ab13a.png";